import { apiClient } from '@/lib/api';

export interface ImportPair {
  baselineFilename: string;
  specimenFilename: string;
}

export interface ImportBatchResult {
  totalPairs: number;
  successCount: number;
  failedCount: number;
  createdTests: { testId: string; baselineFile: string; specimenFile: string }[];
  errors: { baselineFile: string; specimenFile: string; reason: string }[];
}

export const importService = {
  async importMeasurements(
    files: File[],
    pairs: ImportPair[],
    profileId: string,
  ): Promise<ImportBatchResult> {
    const formData = new FormData();
    files.forEach((f) => formData.append('files', f));
    formData.append('pairs', JSON.stringify({ profileId, pairs }));

    // Override the default 'application/json' Content-Type so the browser can
    // set 'multipart/form-data; boundary=...' automatically for this request.
    const response = await apiClient.post<ImportBatchResult>(
      '/api/v1/import/measurements',
      formData,
      { headers: { 'Content-Type': undefined } },
    );
    return response.data;
  },

  async importFromAppExport(
    file: File,
    profileId: string,
  ): Promise<ImportBatchResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('profileId', profileId);

    const response = await apiClient.post<ImportBatchResult>(
      '/api/v1/import/app-export',
      formData,
      { headers: { 'Content-Type': undefined } },
    );
    return response.data;
  },
};
